<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2z"><a id="page_v"></a>CONTENTS</h2>
<p class="toc"><a href="#/xhtml/preface#eth">·<span class="space"><em>Ethnomusicology Multimedia Series Preface</em></span></a></p>
<p class="toc"><a href="#/xhtml/acknowledgments#ack">·<span class="space"><em>Acknowledgments</em></span></a></p>
<p class="toc1"><a href="#/xhtml/introduction#int">·<span class="space">Introduction  ·  <em>Radical Jewish Music in Manhattan</em></span></a></p>
<p class="toct"><span href="#/xhtml/chapter1#ch1" title="Link target outside of Sample">1<span class="space">Jewish Music  ·  <em>The Art of Getting It Wrong</em></span></span></p>
<p class="toct"><span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample">2<span class="space">Breaking a Thick Silence  ·  <em>A Community Emerges</em></span></span></p>
<p class="toct"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">3<span class="space">From the Inexorable to the Ineffable  ·  <em>John Zorn’s</em> Kristallnacht <em>and the Masada Project</em></span></span></p>
<p class="toct"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">4<span class="space">Rethinking Identity  ·  <em>G - d Is My Co-Pilot’s Queer Dada Judaism</em></span></span></p>
<p class="toct"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">5<span class="space">Shelley Hirsch and Anthony Coleman  ·  <em>Music and Memory from the “Nowhere Place”</em></span></span></p>
<p class="toct"><span href="#/xhtml/epilogue#epi" title="Link target outside of Sample">·<span class="space">Epilogue</span></span></p>
<p class="toc1"><span href="#/xhtml/notes#not" title="Link target outside of Sample">·<span class="space"><em>Notes</em></span></span></p>
<p class="toc"><span href="#/xhtml/source#sou" title="Link target outside of Sample">·<span class="space"><em>Sources</em></span></span></p>
<p class="toc"><span href="#/xhtml/index#ind" title="Link target outside of Sample">·<span class="space"><em>Index</em></span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?9b59bf56